import React from "react"
import { buildFaqPageSchema } from "@/utils/faq-structured-data"

const FaqStructuredData = ({ items }) => {
  if (!items?.length) {
    return null
  }

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify(buildFaqPageSchema(items)),
      }}
    />
  )
}

export default FaqStructuredData
